import { Directive, Input, ElementRef } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Directive({
  selector: '[appIconSvg]'
})
export class IconSvgDirective {

  @Input() itemSVG: string;

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewChecked() {
    this.e.nativeElement.children[0].children[0].innerHTML = this.itemSVG;
  }

  constructor(private e: ElementRef) {
   }

}



// WEBPACK FOOTER //
// /home/ubuntu/demo.airtory.com-stage/src/app/icons/icon-svg.directive.ts